import { render } from "./detailsRequest.vue?vue&type=template&id=685a05a8&scoped=true"
import script from "./detailsRequest.vue?vue&type=script&lang=js"
export * from "./detailsRequest.vue?vue&type=script&lang=js"

import "./detailsRequest.vue?vue&type=style&index=0&id=685a05a8&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685a05a8"]])

export default __exports__